"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    accessibility: {
      a11yLabel: 'Quantity selector',
      increaseButton: 'Increase quantity',
      decreaseButton: 'Decrease quantity'
    },
    errors: {
      numberIsTooSmall: minNumber => `You can enter a number equal or greater than ${minNumber}.`,
      numberIsTooBig: maxNumber => `You can enter a number equal or less than ${maxNumber}.`,
      invalidCharacters: 'Try using numbers only. Alphabetical or symbols characters are not allowed.'
    }
  },
  fr: {
    accessibility: {
      a11yLabel: 'Sélecteur de quantité',
      increaseButton: `Augmenter la quantité`,
      decreaseButton: `Réduire la quantité`
    },
    errors: {
      numberIsTooSmall: minNumber => `Vous pouvez saisir un nombre égal ou supérieur à ${minNumber}.`,
      numberIsTooBig: maxNumber => `Vous pouvez saisir un nombre égal ou inférieur à ${maxNumber}.`,
      invalidCharacters: `Essayez d'utiliser seulement des chiffres. Les caractères alphabétiques ou les symboles ne sont pas permis.`
    }
  }
};